import React from 'react';
import { formatDateNaturalLanguage } from "../../../utils";
import { COMPANY_OWNER_LOGO, COMPANY_LOGO } from 'constants/config';

const IMG_COMPANY_OWNER_LOGO = COMPANY_OWNER_LOGO ?? "/assets/logos/company-owner-logo.png";
const IMG_COMPANY_LOGO = COMPANY_LOGO ?? "assets/logos/company-logo.png";
const LetterPrint = ({ process, config, qrCode }) => {
    const department = process.unidade_administrativa_responsavel || {};
    const infracao = process.infracao || {};

    return (
        <>
            <div className="page">
                <div className="panel">
                    <div className="content">
                        <table style={{ marginTop: '50px' }}>
                            <tr className="font-size-4 padding-3">
                                <td width="27%">Auto de Infração:
                                    <span>{infracao.numero_ait}</span>
                                </td>
                                <td width="24%">PLACA/UF:
                                    <span>{infracao.placa_veiculo} / {infracao.uf_placa_veiculo}</span>
                                </td>
                                <td width="30%" className="center">
                                    {process.numero}
                                </td>
                            </tr>
                            <tr className="font-size-3 padding-3">
                                <td colSpan="3">
                                    DESTINATÁRIO:
                                    <br />
                                    {process.nome_condutor?.toUpperCase()}
                                    <br />
                                    {process.logradouro_requerente?.toUpperCase()} {process.numero_requerente?.toUpperCase()} {process.bairro_requerente?.toUpperCase()}
                                    <br />
                                    {process.complemento_requerente && (<>{process.complemento_requerente.toUpperCase()}
                                        <br /></>)}
                                    {process.cidade_requerente?.toUpperCase()} / {process.uf_requerente?.toUpperCase()}
                                    <br />
                                    {process.cep_requerente}
                                </td>
                            </tr>
                        </table>

                        <table>
                            <tr className="padding-3">
                                <td className="no-border-top no-border-right">
                                    <span className="font-size-3">PARA USO DOS CORREIOS</span>
                                    <div className="panel-checkbox font-size-2">
                                        {[
                                            "Mudou-se", "Falecido", "Ausente", "Endereço Insuficiente",
                                            "Desconhecido", "Não Procurado", "Não existe o nº. indicado",
                                            "Recusado", "Outros"
                                        ].map((text, index) => (
                                            <div className="checkbox" key={index}>
                                                <div className="rectangle"></div> <span>{text}</span>
                                            </div>
                                        ))}
                                    </div>
                                </td>
                                <td className="no-border-top no-border-left font-size-3">
                                    <p></p>
                                    <p></p>
                                    <div>
                                        INFORMAÇÃO PRESTADA POR <span className="line-signature"></span>
                                    </div>
                                    <div>
                                        <span className="write-date">Data: <span className="line-day"></span>/<span className="line-month"></span>/<span className="line-year"></span></span>
                                        <span className="signature-condutor">Responsável</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="padding-3">
                                <td colSpan="2">
                                    <img style={{ marginRight: '10px', width: '138px', height: '40px', float: 'left' }} src={IMG_COMPANY_OWNER_LOGO} alt="logo" />
                                    {config.company_name?.toUpperCase()} - {config.company_acronym?.toUpperCase()}<br />
                                    {config.company_address?.toUpperCase()}<br />
                                    {config.company_district?.toUpperCase()}<br />
                                    {config.company_cep} - {config.company_city?.toUpperCase()} - {config.company_uf?.toUpperCase()}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                {[...Array(11)].map((_, i) => <br key={i} />)}

                <div>
                    <img style={{ marginRight: '10px', width: '80px', height: '23px', float: 'left' }} src={IMG_COMPANY_LOGO} alt="logo" />
                    <div className="pull-left font-size-4">
                        {config.company_name?.toUpperCase()}
                        <br />
                        &nbsp;
                        <br />
                        <br />
                        REMETENTE:
                        <br />
                        {config.company_name?.toUpperCase()} - {config.company_acronym?.toUpperCase()}
                        <br />
                        {config.company_address?.toUpperCase()}
                        <br />
                        {config.company_district?.toUpperCase()} {config.company_cep} - {config.company_city?.toUpperCase()} - {config.company_uf?.toUpperCase()}
                    </div>
                    <div className="carta-circle">
                        <div className="first-item font-size-5">
                            CARTA
                        </div>
                        <div className="second-item">
                            {config.mail_contract?.toUpperCase()}
                        </div>
                        <div className="third-item">
                            <img width="100px" src={'/assets/logos/logo-correios.png'} alt="correios" />
                        </div>
                    </div>
                </div>

                <div style={{ clear: 'both' }}></div>

                {[...Array(3)].map((_, i) => <br key={`receiver-${i}`} />)}

                <div className="receiver font-size-4">
                    DESTINATÁRIO:
                    <br />
                    Nome: {process.nome_condutor?.toUpperCase()}
                    <br />
                    Endereço: {process.logradouro_requerente?.toUpperCase()} {process.numero_requerente?.toUpperCase()}
                    <br />
                    {process.complemento_requerente && <>Complemento: {process.complemento_requerente.toUpperCase()}<br /></>}
                    Bairro: {process.bairro_requerente?.toUpperCase()}
                    <br />
                    Cidade: {process.cidade_requerente?.toUpperCase()} / {process.uf_requerente?.toUpperCase()}
                    <br />
                    CEP: {process.cep_requerente}
                </div>

                {[...Array(11)].map((_, i) => <br key={`footer-space-${i}`} />)}

                <div className="table-footer" style={{ display: 'none' }}>
                    <table style={{ borderCollapse: 'separate' }}>
                        <tr className="font-size-4">
                            <th style={{ padding: '4px' }}>OBSERVAÇÕES RELATIVAS À INTERPOSIÇÃO DE RECURSO</th>
                        </tr>
                        <tr className="padding-1 font-size-1">
                            <td style={{ height: '76px' }}>
                                Para interpor RECURSO junto à JARI deve o recorrente apresentar a seguinte documentaçao em fotocópia: Carteira Nacional de Habilitação, Carteira de Identidade, Documento do Veículo(DUT), alegação de defesa, notificação da multa de Trânsito. Se for pessoa jurídica apresentar cópia do contrato social.<br /><br />
                                {config.sne && (
                                    <>Ganhe 40% de desconto nas suas infrações de trânsito. Baixe o Sistema de Notificação Eletrônica<br />
                                        https://servicos.serpro.gov.br/sne/</>
                                )}
                            </td>
                        </tr>
                    </table>
                    <table style={{ borderCollapse: 'separate' }}>
                        <tr>
                            <td width="25%" className="center">
                                Mantenha atualizado seus dados cadastrais junto ao DETRAN que licenciou o veículo.
                            </td>
                            <td width="25%" className="center">
                                Data limite para interposição de RECURSO: {infracao.data_vencimento_desconto}
                            </td>
                            <td width="25%" className="center">
                                {config.company_phone_whatsapp ?
                                    `INFORMAÇÕES, LIGUE / WHATSAPP: ${config.company_phone}` :
                                    `INFORMAÇÕES, LIGUE: ${config.company_phone}`}
                            </td>
                            <td width="25%" className="center">
                                {config.company_address?.toUpperCase()} {config.company_cep}
                            </td>
                        </tr>
                    </table>
                    {config.sne && (
                        <>
                            <br /><br />
                            <div className="font-size-5">
                                <img src={qrCode} alt="QRCode" align="right" style={{ width: '100px' }} />
                                Ganhe 40% de desconto nas suas infrações de trânsito.<br /><br />
                                Para saber mais, acesse: https://servicos.serpro.gov.br/sne
                            </div>
                        </>
                    )}
                </div>
            </div>

            <div className="new-page"></div>

            <div className="page" style={{ fontSize: '20px' }}>
                <div className="center-flex">
                    <img src={IMG_COMPANY_OWNER_LOGO} width="200" alt="logo" /><br />
                    <div style={{textAlign: 'center'}}>
                        <strong>{config.company_state_description}</strong><br/>
                        <strong>{config.company_owner_name}</strong><br/>
                        <strong>{config.company_name}</strong><br/>
                        <strong>
                            {(department.descricao &&
                                (department.descricao !== department.sigla
                                    ? `${department.descricao} - ${department.sigla}`
                                    : department.descricao)
                            )?.toUpperCase()}
                        </strong>
                    </div>
                </div>

                {[...Array(4)].map((_, i) => <br key={`date-space-${i}`}/>)}

                <div style={{textAlign: 'right'}}>
                    {config.company_city?.toUpperCase()}, {formatDateNaturalLanguage(process.data_limite_julgamento)?.toUpperCase()}
                </div>

                {[...Array(5)].map((_, i) => <br key={`ref-space-${i}`}/>)}

                <div style={{margin: '0 auto', width: '80%'}}>
                    Ref. Processo n° <strong>{process.numero} de {process.data_criacao}</strong><br/>
                    Notificação: <strong>{infracao.numero_ait?.toUpperCase()}</strong> Código: <strong>{infracao.codigo_tipo_infracao}{infracao.desdobramento_tipo_infracao}</strong><br />
                    Senhor(a): <strong>{process.nome_condutor?.toUpperCase()}</strong><br />
                </div>

                {[...Array(5)].map((_, i) => <br key={`decision-space-${i}`} />)}

                <div style={{ textAlign: 'justify' }}>
                    {process.status === 'DEFERIDA' && (
                        <>Comunicamos a Vossa Senhoria com referência ao processo supra citado, esta <strong>{(department.descricao && (department.descricao !== department.sigla ? `${department.descricao} - ${department.sigla}` : department.descricao))?.toUpperCase()}</strong>, após análise, julgou <strong>PROCEDENTE</strong>.{[...Array(9)].map((_, i) => <br key={`accepted-space-${i}`}/>)}</>
                    )}
                    {process.status === 'INDEFERIDA' && (
                        <>
                            Comunicamos a Vossa Senhoria com referência ao processo supra citado, esta <strong>{(department.descricao && (department.descricao !== department.sigla ? `${department.descricao} - ${department.sigla}` : department.descricao))?.toUpperCase()}</strong>, após análise, julgou <strong>IMPROCEDENTE</strong> o seu pedido, não acatando a sua justificativa com base na infrigência do: <strong>ART. {infracao.amparo_legal?.toUpperCase() || '____________'} CTB (Código de Trânsito Brasileiro), abaixo transcrito:</strong>.<br/><br/>
                            {process.tipo === 'NP' ? (
                                <>Cumpre-nos ainda informar que desta decisão cabe recurso a ser interposto junto ao CETRAN/PB (Conselho Estadual de Trânsito) no prazo de 30 (trinta) dias contados do recebimento desta notificação, de acordo com o <strong>ART. 288</strong> do CTB <strong>(Código de Trânsito Brasileiro), abaixo transcrito:</strong>
                                    <br/><br/>
                                    <strong>ART 288 - Das decisões da JARI cabe o recurso a ser interposto, na forma do artigo seguinte, no prazo de trinta dias contados da publicação ou notificação da decisão.</strong>
                                </>
                            ) : (
                                <>De posse da <strong>NOTIFICAÇÃO DE PENALIDADE</strong>, Vossa senhoria poderá, no prazo indicado no documento, impetrar recurso junto à <strong>JARI (Junta Administrativa de Recursos de Infrações)</strong> de acordo com o Art. 282 do Código de Trânsito Brasileiro.</>
                            )}
                        </>
                    )}
                    {[...Array(5)].map((_, i) => <br key={`end-space-${i}`}/>)}
                </div>

                <div style={{ textAlign: 'center' }}>Atenciosamente,</div>
            </div>
        </>
    );
};

export default LetterPrint;
